export const FastSearchState = () => ({})
